import React, { FunctionComponent } from 'react'
import Skeleton, { ISkeletonProps } from 'react-native-reanimated-skeleton'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

export interface BaseSkeletonProps extends Omit<ISkeletonProps, 'boneColor' | 'highlightColor' | 'isLoading'> {
  isLoading?: boolean
}

export const BaseSkeleton: FunctionComponent<BaseSkeletonProps> = ({
  isLoading = true,
  animationDirection = 'horizontalRight',
  children,
  ...restOfProps
}) => {
  const { colors } = useTheme() as ThemeType
  return (
    <Skeleton
      animationDirection={animationDirection}
      boneColor={colors.skeletonBoneColor}
      highlightColor={colors.skeletonHighlightColor}
      isLoading={isLoading}
      // animationType='shiver' (the default) uses ShiverBone which mounts an Animated.View and triggers
      // Reanimated's cloneShadowTreeWithNewPropsRecursive on iOS new arch. This hits a data race in
      // ShadowNodeFamily::nativeProps_DEPRECATED causing a SIGABRT in Yoga's StyleValuePool::getLength.
      // This is an open bug in react-native-reanimated (issue #7666), unfixed through v3.19.5 / v4.x.
      // Workaround: 'none' uses StaticBone instead, avoiding the Animated.View mount that triggers the crash.
      animationType='none'
      {...restOfProps}
    >
      {children}
    </Skeleton>
  )
}
